export const email = {
  // Dashboard
  loadingModule: 'Cargando módulo de email...',
  welcomeToEmailModule: 'Bienvenido al módulo de Email',
  connectAccountsToStart: 'Conecta tus cuentas de email para empezar a gestionar tus mensajes',
  connectFirstAccount: 'Conectar primera cuenta de email',
  whatCanYouDo: '¿Qué puedes hacer con el módulo de Email?',
  manageMultipleAccounts: 'Gestionar múltiples cuentas',
  manageMultipleAccountsDesc: 'Conecta Gmail, Outlook, Yahoo y proveedores personalizados',
  sendEmails: 'Enviar emails',
  sendEmailsDesc: 'Redacta y envía emails desde cualquiera de tus cuentas',
  configureAndSync: 'Configurar y sincronizar',
  configureAndSyncDesc: 'Controla la sincronización y configuración avanzada',
  activeAccounts: 'Cuentas activas',
  unreadMessages: 'Mensajes no leídos',
  totalMessages: 'Total mensajes',
  inbox: 'Bandeja de entrada',
  settings: 'Configuración',
  configuration: 'Configuración',
  loadingMessages: 'Cargando mensajes...',
  noMessages: 'No tienes mensajes',
  noMessagesDesc: 'Tus mensajes aparecerán aquí cuando se sincronicen',
  configureAccounts: 'Configurar cuentas',
  latestMessages: 'Últimos mensajes',
  messagesSynced: '{count} mensajes sincronizados',
  newBadge: 'Nuevo',
  unknownAccount: 'Cuenta desconocida',
  demoFunctionAlert: 'Función de demostración: Este módulo simula el envío de emails. En un entorno de producción, se conectaría con servidores SMTP reales.',

  // Compose
  composeEmail: 'Redactar Email',
  composeAndSend: 'Compose y envía un nuevo email desde una de tus cuentas configuradas',
  noActiveAccounts: 'No tienes cuentas de email activas. Agrega una cuenta primero para poder enviar emails.',
  sendingData: 'Datos del envío',
  sendFrom: 'Enviar desde',
  selectAccount: 'Selecciona una cuenta',
  recipients: 'Para (destinatarios)',
  recipientPlaceholder: 'destinatario@ejemplo.com',
  addRecipient: 'Agregar destinatario',
  ccCopy: 'CC (copia)',
  ccPlaceholder: 'cc@ejemplo.com',
  addCC: 'Agregar CC',
  addBCC: 'Agregar BCC',
  bccHiddenCopy: 'BCC (copia oculta)',
  bccPlaceholder: 'bcc@ejemplo.com',
  messageContent: 'Contenido del mensaje',
  subject: 'Asunto',
  subjectPlaceholder: 'Asunto del email',
  message: 'Mensaje',
  messagePlaceholder: 'Escribe tu mensaje aquí...',
  cancel: 'Cancelar',
  sending: 'Enviando...',
  sendEmail: 'Enviar Email',

  // Settings
  generalSettings: 'Configuración General',
  adjustGlobalSettings: 'Ajusta la configuración global del módulo de email',
  synchronization: 'Sincronización',
  autoSync: 'Sincronización automática',
  syncInterval: 'Intervalo de sincronización',
  minutes5: '5 minutos',
  minutes15: '15 minutos',
  minutes30: '30 minutos',
  hour1: '1 hora',
  hours2: '2 horas',
  maxMessages: 'Máximo de mensajes por cuenta',
  emailNotifications: 'Notificaciones de nuevos emails',
  syncing: 'Sincronizando...',
  syncAllAccounts: 'Sincronizar todas las cuentas',
  emailAccounts: 'Cuentas de Email ({count})',
  manageConnectedAccounts: 'Gestiona tus cuentas de email conectadas',
  noAccountsConfigured: 'No tienes cuentas de email configuradas',
  connectFirstAccountBtn: 'Conectar primera cuenta',
  active: 'Activa',
  inactive: 'Inactiva',
  enabled: 'Habilitado',
  disabled: 'Deshabilitado',
  createdAgo: 'Creada {time}',
  synchronize: 'Sincronizar',
  activate: 'Activar',
  deactivate: 'Desactivar',
  delete: 'Eliminar',
  securityAndPrivacy: 'Seguridad y Privacidad',
  dataProtectionInfo: 'Información sobre cómo se protegen tus datos',
  encryptedCredentials: 'Cifrado de credenciales',
  encryptedCredentialsDesc: 'Tus contraseñas se almacenan encriptadas con AES-256',
  secureConnections: 'Conexiones seguras',
  secureConnectionsDesc: 'Todas las conexiones IMAP/SMTP usan SSL/TLS',
  limitedAccess: 'Acceso limitado',
  limitedAccessDesc: 'Solo tú tienes acceso a tus cuentas y mensajes',
  deleteConfirm: '¿Estás seguro de que deseas eliminar esta cuenta de email? Se eliminarán todos los mensajes asociados.',

  // Account Setup
  backToProviderSelection: 'Volver a Selección de Proveedor',
  configureAccount: 'Configurar Cuenta de {provider}',
  enterAccountDetails: 'Ingresa los detalles de tu cuenta para conectar tu email',
  gmailDetected: '¡Gmail detectado! Asegúrate de usar tu Contraseña de Aplicación (16 caracteres), no tu contraseña regular.',
  generateAppPassword: 'Generar Contraseña de Aplicación →',
  outlookDetected: '¡Outlook detectado! Asegúrate de que IMAP esté habilitado en tu configuración de Outlook.',
  checkOutlookSettings: 'Verificar Configuración de Outlook →',
  yahooDetected: '¡Yahoo detectado! Necesitas usar una Contraseña de Aplicación para aplicaciones de terceros.',
  generateYahooAppPassword: 'Generar Contraseña de Aplicación de Yahoo →',
  accountConfiguration: 'Configuración de Cuenta',
  credentialsSecure: 'Tus credenciales se cifran y almacenan de forma segura',
  emailAddress: 'Dirección de Email',
  displayName: 'Nombre para Mostrar',
  displayNamePlaceholder: 'Tu Nombre',
  appPassword: 'Contraseña de Aplicación',
  password: 'Contraseña',
  appPasswordPlaceholder: 'Contraseña de Aplicación de 16 caracteres',
  passwordPlaceholder: 'Tu contraseña de email',
  useAppPasswordNote: 'Usa la Contraseña de Aplicación que generaste, no tu contraseña de cuenta regular',
  serverConfiguration: 'Configuración del Servidor',
  imapServer: 'Servidor IMAP',
  imapPort: 'Puerto IMAP',
  smtpServer: 'Servidor SMTP',
  smtpPort: 'Puerto SMTP',
  backToGuide: 'Atrás',
  connecting: 'Conectando...',
  connectAccount: 'Conectar Cuenta',
  securityPrivacy: 'Seguridad y Privacidad',
  securityPoint1: '• Tus credenciales se cifran y almacenan de forma segura en la base de datos.',
  securityPoint2: '• Solo tú tienes acceso a tus cuentas y mensajes de email.',
  securityPoint3: '• Recomendamos usar Contraseñas de Aplicación en lugar de tu contraseña de cuenta principal.',
  securityPoint4: '• Puedes desconectar tu cuenta en cualquier momento desde la configuración.',

  // Reader
  selectMessage: 'Selecciona un mensaje para leer',
  back: 'Volver',
  markAsUnread: 'Marcar como no leído',
  download: 'Descargar',
  noSubject: '(Sin asunto)',
  to: 'Para',
  account: 'Cuenta',
  attachments: 'adjunto(s)',
  loadingContent: 'Cargando contenido...',
  noContent: 'Sin contenido',
  attachedFiles: 'Archivos adjuntos',
  reply: 'Responder',
  replyAll: 'Responder a todos',
  forward: 'Reenviar',
  deleteConfirmMessage: '¿Estás seguro de que deseas eliminar este mensaje?',
  
  // Module Page
  moduleTitle: 'Módulo de Email',
  moduleDescription: 'Gestiona tus cuentas de correo desde un solo lugar',
  viewMetrics: 'Ver Métricas',
  hideMetrics: 'Ocultar Métricas',
  totalMessagesShort: 'Total mensajes',
  unreadMessagesShort: 'No leídos',
  activeAccountsShort: 'Cuentas activas',
  sentMessages: 'Enviados',
  selectingAccount: 'Seleccionando cuenta...',
  connectFirstEmailAccount: 'Conecta tu primera cuenta de email',
  emailModuleDescription: 'Para comenzar a usar el módulo de email, necesitas conectar al menos una cuenta de correo como Gmail, Outlook o una configuración personalizada.',
  emailReading: 'Lectura de Emails',
  emailReadingDesc: 'Accede a tu bandeja de entrada y lee tus mensajes desde una interfaz unificada',
  emailSending: 'Envío de Emails',
  emailSendingDesc: 'Redacta, responde y reenvía emails directamente desde la aplicación',
  synchronizationShort: 'Sincronización',
  synchronizationShortDesc: 'Mantén tus mensajes sincronizados automáticamente con el servidor',
  emailManagement: 'Gestión de Email',
  syncAll: 'Sincronizar Todo',
  newEmail: 'Nuevo Email',
  addAccount: 'Agregar Cuenta',
  inboxTab: 'Bandeja de Entrada',
  sent: 'Enviados',
  drafts: 'Borradores',
  spam: 'Spam',
  trash: 'Papelera',
  folders: 'Carpetas',
  templates: 'Plantillas',
  accounts: 'Cuentas',
  recommended: 'Recomendado',
  functional: 'Funcional',
  demoOnly: 'Solo demos',

  // Inbox and Filters
  searchInAllFields: 'Buscar en todos los campos...',
  searchInEmails: 'Buscar en emails...',
  filters: 'Filtros',
  advancedFilters: 'Filtros Avanzados',
  clearAll: 'Limpiar todo',
  compose: 'Redactar',
  unreadCount: '{count} no leídos',
  allFolders: 'Todas las carpetas',
  onlyRead: 'Solo leídos',
  onlyUnread: 'Solo no leídos',
  allStatus: 'Todos',

  // Folder names
  inboxFolder: 'Bandeja de entrada',
  sentFolder: 'Enviados',
  draftsFolder: 'Borradores',
  spamFolder: 'Spam',
  trashFolder: 'Papelera',
  
  // Status and sync
  connected: 'Conectado',
  synchronized: 'Sincronizado',
  syncStatus: 'Estado de Sincronización',
  notSynchronized: 'Sin sincronizar',
  syncButton: 'Sincronizar',
  cacheManager: 'Cache Manager',
  messagesLoading: 'Cargando mensajes...',
  noMessagesFound: 'No se encontraron mensajes',
  noMessagesAvailable: 'No hay mensajes disponibles',
  loadMoreMessages: 'Cargar más mensajes'
};